<script lang="ts">
	import { page } from '$app/state';
	import MarketingSeoHead from '$lib/components/marketing/MarketingSeoHead.svelte';
	import { marketingCanonicalPath } from '$lib/utils/marketing-routes';
	import { marketingSeoMeta } from '$lib/utils/marketing-seo';
	import { getLocale } from '@/paraglide/runtime';
	import './marketing.css';

	let { children } = $props();

	const locale = $derived(getLocale());
	const canonicalPath = $derived(marketingCanonicalPath(page.url.pathname));
	const seoMeta = $derived.by(() => {
		void locale;
		return marketingSeoMeta(canonicalPath);
	});
</script>

<svelte:head>
	<link
		rel="preload"
		href="/fonts/newsreader/variable/woff2/Newsreader[opsz,wght].woff2"
		as="font"
		type="font/woff2"
		crossorigin="anonymous"
	/>
	<link
		rel="preload"
		href="/fonts/newsreader/variable/woff2/Newsreader-Italic[opsz,wght].woff2"
		as="font"
		type="font/woff2"
		crossorigin="anonymous"
	/>
</svelte:head>

{#if seoMeta}
	<MarketingSeoHead meta={seoMeta} canonicalPath={canonicalPath} />
{/if}

<div class="zp min-h-screen">
	{@render children?.()}
</div>
